// The current drink images only support 5 states but we have 6 dimensions we're reviewing ATM
// For now I'm just going to normalize it to 5 states but we'll need to revisit this. A better solution
// might be an SVG with animated fill
export const calculatePercentageStop = (matches: number, total: number): number => {
	return Math.min(matches / Math.min(total, 5), 1) * 100;
};
